var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7774 16.6466L31.2292 30.0712L30.5648 31.4137L5.04983 19.6L6.7774 16.6466Z",
    fill: "#27DD83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59468 44.0329L24.4518 42.2877V44.7041L0 49L1.59468 44.0329Z",
    fill: "#27DD83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1229 0.805479L37.608 21.211L40 20.4055L28.4385 0L23.1229 0.805479Z",
    fill: "#27DD83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkGreen);
export default __webpack_public_path__ + "static/media/spark-green.003e0308a4d6df8a415b2e2bc065e200.svg";
export { ForwardRef as ReactComponent };